/**
 * PromoBannersPageV2 — redesigned Upgrade Banners list shell.
 *
 * Single coral "+ Add Banner" header action; the body
 * (PromoBannersTableV2) handles drag-to-reorder, status pills, and
 * inline edit affordances.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PromoBannersTableV2 from '../../PromoBannersTable/v2/PromoBannersTableV2';
import { PageHeader, Button } from '../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function PromoBannersPageV2() {
  const total = useSelector((s) =>
    Array.isArray(s.banners?.banners) ? s.banners.banners.length : undefined,
  );
  const totalLabel = total != null ? `${total.toLocaleString()} total` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Engagement & Promotions"
        title="Upgrade Banners"
        total={totalLabel}
        actions={
          <Link to="/banners/add" className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>
              Add Banner
            </Button>
          </Link>
        }
      />
      <PromoBannersTableV2 />
    </div>
  );
}
